<template>
	<svg
		viewBox="0 0 24 24"
		stroke="currentColor"
		stroke-width="2"
		fill="none"
		stroke-linecap="round"
		stroke-linejoin="round"
		v-html="icon"
	/>
</template>

<script setup lang="ts">
	interface Props {
		icon: string | HTMLElement
	}
	defineProps<Props>();
</script>
